/******************************************************************************
 * ReleaseLog Hook
 * version: 1.0.1, release: 10.06.2019
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
******************************************************************************/

import React, { useContext, useEffect } from 'react';
import './ReleaseLog.scss';
import { State, Action } from './Provider';
import Store from './Store';
import Sys from './lib.r2/utils/SystemUtils';
import { TabView } from './lib.r3/ui/ui-controls';
import store from './Store';
import { CloseButton, SelectButton } from './Assets';


//============================================================================= ReleaseLog Hook
export default function ReleaseLog() {
	const action = useContext(Action);
	const state = useContext(State);

	const [isTest, releaseLog] = Store.use(['isTest', 'releaseLog'])
	console.info('isTest:', isTest)

	const onFullscreen = e => {
		Sys.switchFullscreen()
	}

	return (
		<div className='release-log-view'>
			<div className='release-log-header'>
				<div className='release-log-title'>Release-Log</div>
				{/* <SelectButton label={isTest? 'Debug = On' : 'Debug = Off' }
					selected={isTest}
					onClick={e => {
						Store.set({'isTest':!isTest})
					}}
				/>
				<SelectButton label={'fullscreen'}
					onClick={onFullscreen}
				/> */}
				<CloseButton onClick={e => action('open-release', false)} />
			</div>

			<div className='release-log'>
				{releaseLog}
			</div>
		</div>
	)


	// return (
	// 	<div className='release-log-view'>
	// 		<TabView onClose={e => action('open-release', false)}>
	// 			<div label='Release log' className='release-log'>
	// 				{releaseLog}
	// 			</div>
	// 			<InfoView label='Info' />
	// 			<div label='Settings' className='settings-view'>
	// 				{/* <SelectButton label='Clear Site Data' selected={true} onClick={e => Store.clearSiteData()} /> */}
	// 			</div>
	// 		</TabView>
	// 	</div>
	// )
}
